import { 
  DashboardStats, 
  SalesData, 
  DashboardOrder, 
  DashboardNotification, 
  LowStockItem 
} from './dashboard.service';

// Generate random date within a range
const randomDate = (start: Date, end: Date) => {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
};

// Generate random number within a range
const randomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

// Generate random trend (-20 to +20)
const randomTrend = () => {
  return Math.floor(Math.random() * 41) - 20;
};

// Generate mock stats
export const mockStats: DashboardStats = {
  total_sales: 45678.90,
  total_orders: 342,
  active_customers: 156,
  inventory_value: 23456.78,
  trends: {
    sales: randomTrend(),
    orders: randomTrend(),
    customers: randomTrend(),
    inventory: randomTrend()
  }
};

// Generate mock sales data for the last 30 days
export const mockSalesData: SalesData[] = Array.from({ length: 30 }, (_, i) => {
  const date = new Date();
  date.setDate(date.getDate() - (29 - i));
  
  return {
    date: date.toISOString().split('T')[0],
    sales: randomNumber(500, 3000),
    orders: randomNumber(10, 50)
  };
});

// Generate mock orders
export const mockOrders: DashboardOrder[] = Array.from({ length: 20 }, (_, i) => {
  const orderDate = randomDate(
    new Date(new Date().setDate(new Date().getDate() - 7)),
    new Date()
  );
  
  const paymentMethods = ['cash', 'credit_card', 'debit_card', 'mobile_payment'];
  const statuses: ('completed' | 'pending' | 'cancelled')[] = ['completed', 'pending', 'cancelled'];
  
  return {
    id: `ORD-${1000 + i}`,
    customer_name: `Customer ${i + 1}`,
    order_date: orderDate.toISOString(),
    total_amount: randomNumber(20, 200),
    status: statuses[Math.floor(Math.random() * statuses.length)],
    payment_method: paymentMethods[Math.floor(Math.random() * paymentMethods.length)]
  };
});

// Generate mock notifications
export const mockNotifications: DashboardNotification[] = Array.from({ length: 10 }, (_, i) => {
  const notificationDate = randomDate(
    new Date(new Date().setDate(new Date().getDate() - 3)),
    new Date()
  );
  
  const types: ('warning' | 'success' | 'info' | 'error')[] = ['warning', 'success', 'info', 'error'];
  
  return {
    id: `NOTIF-${100 + i}`,
    type: types[Math.floor(Math.random() * types.length)],
    message: `This is a sample notification message for testing purposes.`,
    timestamp: notificationDate.toISOString(),
    isRead: Math.random() > 0.5
  };
});

// Generate mock low stock items
export const mockLowStockItems: LowStockItem[] = Array.from({ length: 8 }, (_, i) => {
  const categories = ['Beverages', 'Snacks', 'Main Course', 'Desserts', 'Appetizers'];
  const lastRestockDate = randomDate(
    new Date(new Date().setDate(new Date().getDate() - 30)),
    new Date(new Date().setDate(new Date().getDate() - 1))
  );
  
  return {
    id: `ITEM-${200 + i}`,
    name: `Product ${i + 1}`,
    stock_quantity: randomNumber(1, 10),
    minStockLevel: 15,
    maxStockLevel: 100,
    lastRestockDate: lastRestockDate.toISOString(),
    unit: 'pcs'
  };
}); 